import script from "./CreateResult.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateResult.vue?vue&type=script&setup=true&lang=js"

import "./CreateResult.vue?vue&type=style&index=0&id=bbb7ae1e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbb7ae1e"]])

export default __exports__